<template>
    <div>
        
		<div class="page-filter-box">
		    <el-row :gutter="20">
		        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
		            <el-input v-model="params.searchValue" class="input-with-select" size="small">
		                <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
		                    <el-option label="接收手机" :value="1"></el-option>
		                    <el-option label="赠票名称" :value="2"></el-option>
							<el-option label="票品id" :value="3"></el-option>
		                </el-select>
		            </el-input>
		        </el-col>
		        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>					
		        </el-col>
		    </el-row>
		</div>
		 <div class="page-btns-box">
			<el-button type="primary" icon="el-icon-data-analysis" @click="$refs.presentStatistic.show()" size="small" :disabled="haveEditAudit" plain>发放统计</el-button>
			<el-button v-if="$utils.have('/activity/export/presentRecords')" type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">批量导出</el-button>
			 
			 
		 </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="dataLoading"
                size="small"
                stripe
            >
                <el-table-column prop="statusView" label="状态">
                </el-table-column>
				<el-table-column prop="ticketCode" label="票品Code"  min-width="100"></el-table-column>
				<el-table-column prop="ticketPriceId" label="票品id"></el-table-column>
                <el-table-column prop="ticketPriceName" label="赠票名称" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column v-if="isSeat == 1" prop="seatName" label="座位号"></el-table-column>
				<el-table-column prop="realNameView" label="是否实名"  min-width="80"></el-table-column>
                <el-table-column prop="telephone" label="接收手机" min-width="120"></el-table-column>				
                <el-table-column  label="观演人信息"  min-width="150">
					<template slot-scope="scope">
						<p v-if="scope.row.documentName">{{scope.row.documentName}}</p>
						<p v-if="scope.row.documentNumber">{{scope.row.documentNumber}}</p>	
						<p v-if="!scope.row.documentNumber && !scope.row.documentNumber" class="color-danger">暂无</p>	
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sendUserName" label="发放人" ></el-table-column>
                <el-table-column prop="sendTime" label="最新发送短信时间" min-width="150"></el-table-column>
                <el-table-column v-if="!haveEditAudit" fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status == 1 && $utils.have('/activity/sendPresentSms')"
                            type="text"
                            size="small"
                            icon="el-icon-message"
                            @click="sendPresentSms(scope.row.recordId)"
                            >补发短信</el-button
                        >
                        <el-button
                            v-if="scope.row.status == 1 && $utils.have('/activity/presentCancel')"
                            type="text"
                            size="small"
                            icon="el-icon-document-delete"
                            @click="presentCancel(scope.row.recordId,scope.row.ticketCodeId)"
                            >作废删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <present-statistic ref="presentStatistic" :activityId="activityId"></present-statistic>

    </div>
</template>

<script>
import presentStatistic from './present-statistic';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: ""
}
export default {
    props:{
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        isSeat: {
            type:[Number,String],
            default: 0
        }
    },
    components:{presentStatistic},
    data(){
        return{
            dataLoading:false,
            data:null,
            dataList:null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
            },
			downLoading:false,
        }
    },
    created(){
        this.getDataList()
    },
    methods:{
        //获取列表
        getDataList(){
            this.dataLoading = true;
            this.$request({
                url: "/activity/presentRecords",
                data: { ...this.params, activityId: parseInt(this.activityId) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.dataList = result.result;
                    } else {
                        self.$message.error(msg || "获取发放记录失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取发放记录失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {
		    this.params = {
		        ...defaultParams,
		        pageSize: this.params.pageSize,
		    };
		    this.getDataList();
		},
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
		async download(){
		    let filePath;
		    this.downLoading = true;
		    const res = await this.$request({
		        url:'/activity/export/presentRecords',
		        method: 'post',
		        data: { ...this.params, activityId: parseInt(this.activityId) },
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result){
		        filePath = result.url;
		        
		    }else{
		        this.downLoading = false;
		        return this.$message.error(msg || '导出失败');
		    }   
		
		    await downloadFileTmp(filePath, this.activityId +'赠票导出.'+this.$utils.getFileType(filePath));
		
		    this.downLoading = false;
		},
        //补发短信
        sendPresentSms(id){
            this.$confirm('是否确认补发短信', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: "/activity/sendPresentSms",
                    params: { recordId: id },
                    method: "post",
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$message.success('补发成功！');
                            this.getDataList()
                        } else {
                            this.$message.error(msg || "操作失败,请重试");
                        }
                    })
                    .catch(() => {
                        this.$message.error("操作失败,请重试");
                    })
            }).catch(() => {})
        },
        //作废删除
        presentCancel(id,ticketCodeId){
            this.$confirm('是否作废该赠票', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: "/activity/presentCancel",
                    params: { recordId: id,ticketCodeId:ticketCodeId },
                    method: "post",
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList()
                        } else {
                            self.$message.error(msg || "操作失败,请重试");
                        }
                    })
                    .catch(() => {
                        this.$message.error("操作失败,请重试");
                    })
            }).catch(() => {})
        }
    }
}
</script>